import {
  PR_TYPE_LABELS,
  type PrRecordType,
} from "@trainrr/api/exercise-prs";
import {
  formatDistance,
  formatTimeSeconds,
  type DistanceUnit,
} from "@/lib/utils/exerciseTracking";

export const DATE_RANGE_CHIPS = [
  { key: "7d", label: "7D", days: 7 },
  { key: "4w", label: "4W", days: 28 },
  { key: "3m", label: "3M", days: 90 },
  { key: "all", label: "All", days: null },
] as const;

export type DateRangeKey = (typeof DATE_RANGE_CHIPS)[number]["key"];

const roundValue = (value: number) =>
  Number.isInteger(value) ? String(value) : value.toFixed(1).replace(/\.0$/, "");

export function formatPrValue(
  type: PrRecordType,
  snapshot: {
    value: number;
    weight?: number | null;
    reps?: number | null;
    timeSeconds?: number | null;
    distanceMeters?: number | null;
  },
  units: {
    weightUnit: string;
    distanceUnit: DistanceUnit;
    trackingType?: string | null;
  },
): string {
  if (type === "heaviest_weight" || type === "best_1rm") {
    return `${roundValue(snapshot.weight ?? snapshot.value)} ${units.weightUnit}`;
  }
  if (type === "best_set_volume" || type === "best_session_volume") {
    return `${roundValue(snapshot.value)} ${units.weightUnit}`;
  }
  if (type === "best_set_reps" || type === "most_session_reps") {
    return `${Math.round(snapshot.value)} reps`;
  }
  if (type === "longest_time") {
    return formatTimeSeconds(snapshot.timeSeconds ?? snapshot.value) || "—";
  }
  if (type === "longest_distance") {
    return formatDistance(
      snapshot.distanceMeters ?? snapshot.value,
      units.distanceUnit,
      units.trackingType ?? "distance_long",
    );
  }
  return roundValue(snapshot.value);
}

export const PR_MEDAL_COLOR = "#FFD60A";

export function prTypeLabel(type: PrRecordType): string {
  return PR_TYPE_LABELS[type] ?? type;
}
